export default {
	add_new_product: "Ajouter un nouveau produit",
	brand: "Marque",
	detail_sold_products: "Détailler les produits vendus",
	for_more_than_one_product_click_on_the_add_new_product_button_and_fill_in_each_one: "Pour plus d’un produit, cliquez sur le bouton ’Ajouter un nouveau produit’ et complétez l’inscription de chacun.",
	insert_more_sales: "Insérer plus de ventes",
	insert_new_sale: "Insérer une nouvelle vente",
	insert_sale: "Insérer une vente",
	invoice_number: "Numéro de facture",
	no_retailers_found: "Aucun détaillant trouvé",
	no_stores_found: "Aucun magasin trouvé",
	observation: "Remarque",
	processor: "Processeur",
	product_type: "Type de produit",
	products: "Produits",
	quantity_points: "Relevé de points",
	quantity: "Quantité",
	remove_product: "Exclure le produit",
	retailer: "Détaillant",
	sale_date: "Date de Vente",
	send_invoices_to_claim_your_points: "Envoyer vos factures pour réclamer vos points",
	sku: "SKU",
	specify_below_the_product_sold_eligible_that_appears_on_the_invoice_sent: "Précisez ci-dessous le produit vendu qui apparaît sur la facture envoyée.",
	store: "Magasins",
	take_a_picture: "Prendre une photo",
	the_note_number_has_already_been_sent_by_the_user_before: "Le numéro de note a déjà été envoyé par l'utilisateur avant",
	tip: "Conseil",
	upload_invoice: "Envoyer la facture",
	your_sale_has_been_successfully_registered_and_your_points_were_credited_this_points_are_liable_to_be_auditable_before_your_prize_redeem_is_confirmed: "Votre vente a bien été enregistrée et vos points ont été crédités. Ils sont susceptibles d’être vérifiés avant la confirmation de vos achats promotionnels."
}